import { Box, Text } from '@factorialco/deprecated-design-system'

const Done = ({ title, description }: { title: string; description: string }) => {
  return (
    <>
      <Text.Header2>{title}</Text.Header2>
      <Box>{description}</Box>
    </>
  )
}

export default Done
